import { render, staticRenderFns } from "./wristband.vue?vue&type=template&id=7822197b&scoped=true&"
import script from "./wristband.vue?vue&type=script&lang=js&"
export * from "./wristband.vue?vue&type=script&lang=js&"
import style0 from "./wristband.vue?vue&type=style&index=0&id=7822197b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7822197b",
  null
  
)

export default component.exports